import React from 'react'

const SearchButton = () => {
  return (
    <button className="mr-6">
        <i className="fa-sharp fa-solid fa-magnifying-glass text-lg"></i>
    </button>
  )
}

export default SearchButton